import { modifier } from 'ember-modifier';

export default modifier((element, [text], options = {}) => {
  const {
    speed = 50,        // Velocidad en ms por carácter
    delay = 0,         // Delay antes de comenzar
    onComplete,        // Callback cuando termine
    active = false,    // Si debe estar activo
    cursor = true,     // Si debe mostrar cursor
    isLast = false,    // Si es el último elemento (para parpadeo final)
    resetKey = 0       // Clave para forzar reset
  } = options;

  // Variable estática para trackear el último resetKey
  if (!element._lastResetKey) {
    element._lastResetKey = resetKey;
  }

  let timeoutId = null;
  let intervalId = null;
  let currentIndex = 0;
  let isTyping = false;

  const cleanup = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
    isTyping = false;
  };

  const startTyping = () => {
    if (isTyping || !text || !active) return;

    isTyping = true;
    currentIndex = 0;
    element.innerHTML = '';

    timeoutId = setTimeout(() => {
      const typeNextChar = () => {
        if (currentIndex < text.length) {
          const textSoFar = text.substring(0, currentIndex + 1);
          if (cursor) {
            element.innerHTML = textSoFar + '<span class="typewriter-cursor-blink">|</span>';
          } else {
            element.textContent = textSoFar;
          }
          currentIndex++;
          timeoutId = setTimeout(typeNextChar, speed);
        } else {
          // Terminó de escribir
          isTyping = false;

          if (cursor && isLast) {
            // Si es el último elemento, hacer parpadeo final antes de remover cursor
            let blinkCount = 0;
            intervalId = setInterval(() => {
              const cursorSpan = element.querySelector('.typewriter-cursor-blink');
              if (cursorSpan) {
                cursorSpan.style.opacity = cursorSpan.style.opacity === '0' ? '1' : '0';
              }
              blinkCount++;

              if (blinkCount >= 6) { // 3 parpadeos
                if (intervalId) clearInterval(intervalId);
                // Remover el cursor
                const cursorSpan = element.querySelector('.typewriter-cursor-blink');
                if (cursorSpan) {
                  cursorSpan.remove();
                }
              }
            }, 500);
          } else if (cursor) {
            // Para elementos intermedios, remover cursor inmediatamente
            element.textContent = text;
          }

          if (onComplete) {
            onComplete();
          }
        }
      };

      typeNextChar();
    }, delay);
  };

  const resetText = () => {
    cleanup();
    element.innerHTML = ''; // Limpiar tanto texto como HTML
    element.style.borderRight = 'none';
    element.classList.remove('typewriter-cursor');
  };

  // Si cambió el resetKey, forzar reset completo
  if (resetKey !== element._lastResetKey) {
    element._lastResetKey = resetKey;
    resetText();
  }

  // Siempre limpiar primero para asegurar estado limpio
  resetText();

  // Luego inicializar si está activo
  if (active) {
    startTyping();
  }  // Cleanup cuando el elemento se destruye
  return cleanup;
});
